// extracted by mini-css-extract-plugin
export var container = "Pagination-module--container--2W4Fw";
export var meta = "Pagination-module--meta--k+NKm";